import IDataSelect from "../../../interfaces/select.interface"

export const SELECT_DATA: IDataSelect = {
	id: 'comments',
    color: 'error',
    label: false,
    textLabel: "Continuar",
    size:'large',
    value: '',
    items: [],
}

